import React, {useCallback, useEffect, useState} from 'react';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import UserLogList from '../components/UserLogList.js';

// Hledaný výraz může přijít z URL (/userlog/<email>) – bereme ho hned při prvním
// renderu, aby se seznam nenačítal dvakrát.
const getSearchFromUrl = () => {
	if (typeof window === 'undefined' || typeof window.location.pathname.split('/')[2] === 'undefined') {
		return '';
	}

	return decodeURI(window.location.pathname.split('/')[2]);
};

export default function UserLog({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [searchValue, setSearchValue] = useState(getSearchFromUrl);

	useEffect(() => {
		if (getSearchFromUrl() !== '') {
			window.history.pushState({}, document.title, '/userlog');
		}
	}, []);

	const onChangeSearch = (value) => {
		setSearchValue(value);
	};

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)}></Search>

				<div className={`page userlog-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<UserLogList searchValue={searchValue} listRows={usrInfo.LIST_ROWS} onLoadingChange={handleLoadingChange} />
				</div>
			</div>
		</>
	);
}
